import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setSubcategories, setActiveCategoryId, setActiveCategory, resetTiles, tileCounterHack } from '../../../../Base/Actions/index';
import { stringEndsWith } from '../../../../Base/helper';

// Import assets
import './navlink.scss';

class NavLink extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.category.directFilter) {
      if (this.props.activeCategoryId !== this.props.category.id) {
        this.props.resetTiles();
      }
      if (this.props.flyoutVisible) {
        this.props.toggleFlyout(e);
      }
      const subcategories = Object.assign(...this.props.category.items);
      this.props.setSubcategories(this.props.category.items);
      this.props.setActiveCategoryId(this.props.category.id);
      this.props.setActiveCategory(this.props.category);
      this.props.setHashByActiveSubCategories(subcategories);
      setTimeout(this.props.tileCounterHack, 200);
      // TODO: DirectFilter to Article to DirectFilter didnt show any tiles unless you clicked the Filter twice. Setting a Timeout for a late WillReceiveProps trigger solved it but is dirty. Find a better solution.
    } else if (this.props.activeCategoryId === this.props.category.id) {
      this.props.toggleFlyout(e);
    } else {
      if (stringEndsWith('-predefinedNav', this.props.activeCategoryId)) {
        // Remove category hash after directFilter
        this.props.setHashByActiveSubCategories({});
      }
      this.props.openFlyout();
      this.props.setSubcategories(this.props.category.items);
      this.props.setActiveCategoryId(this.props.category.id);
      this.props.setActiveCategory(this.props.category);
    }
  }

  render() {
    const className = ((this.props.activeCategoryId === this.props.category.id) && (this.props.flyoutVisible || this.props.category.directFilter)) ? 'm-navlink m-navlink--active' : 'm-navlink';
    return (
      <li className={className}>
        <a onClick={this.onClick} tabIndex={-1} role="link">
          {this.props.category.title}
        </a>
      </li>
    );
  }
}

NavLink.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.shape,
      title: PropTypes.string,
    })),
    title: PropTypes.string,
    directFilter: PropTypes.bool,
  }),
  flyoutVisible: PropTypes.bool.isRequired,
  activeCategoryId: PropTypes.string.isRequired,
  openFlyout: PropTypes.func.isRequired,
  toggleFlyout: PropTypes.func.isRequired,
  setSubcategories: PropTypes.func.isRequired,
  setActiveCategoryId: PropTypes.func.isRequired,
  setActiveCategory: PropTypes.func.isRequired,
  setHashByActiveSubCategories: PropTypes.func.isRequired,
  resetTiles: PropTypes.func.isRequired,
  tileCounterHack: PropTypes.func.isRequired,
};

NavLink.defaultProps = {
  category: {
    title: '',
  },
};

function mapStateToProps(state) {
  return {
    activeCategoryId: state.navState.activeCategoryId,
    activeSubCategories: state.navState.activeSubCategories,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setSubcategories, setActiveCategoryId, setActiveCategory, resetTiles, tileCounterHack }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NavLink);




// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/NavLink/NavLink.jsx